module.exports = __webpack_public_path__ + "static/HelveticaNowText-Bold.96976e7e3b88662d3531fb76f7f576a7.ttf";